import { render, staticRenderFns } from "./Testimonios.vue?vue&type=template&id=8a3b3d20&scoped=true"
import script from "./Testimonios.vue?vue&type=script&lang=js"
export * from "./Testimonios.vue?vue&type=script&lang=js"
import style0 from "./Testimonios.vue?vue&type=style&index=0&id=8a3b3d20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a3b3d20",
  null
  
)

export default component.exports